import { NSARouterMakerResult } from "namirasoft-account-react";
import { BranchInputRow, BranchRow, CurrencyRow, NamirasoftERPMetaDatabase } from "namirasoft-erp";
import { NSBox, NSBoxBoolean, NSBoxEntity, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class BranchEditPage extends Component<Props>
{
    DefaultCurrency = createRef<NSBoxEntity<CurrencyRow>>();
    Name = createRef<NSBoxString>();
    Country = createRef<NSBoxString>();
    Description = createRef<NSBoxTextArea>();
    Enabled = createRef<NSBoxBoolean>();

    override render()
    {
        let db = new NamirasoftERPMetaDatabase(this.props.account.token_manager, console.error);

        return (
            <ErpLayout<BranchRow, BranchInputRow>
                {...this.props}
                mode={ErpScopeMode.Select}
                fields={[ErpScopeField.Company]}
                pages={{
                    entity: ErpEntities.branch(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): BranchInputRow => ({
                                        company_id: ErpScope.getCompanyId() ?? "",
                                        default_currency_id: this.DefaultCurrency.current?.getValueOne() ?? "",
                                        name: this.Name.current?.getValue() ?? "",
                                        country: this.Country.current?.getValue() ?? null,
                                        description: this.Description.current?.getValue() ?? null,
                                        enabled: this.Enabled.current?.getValueBool() ?? true,
                                        branch_category: [],
                                        branch_tag: [],
                                        branch_field: [],
                                    }),
                                    setRow: (row: BranchRow) =>
                                    {
                                        ErpScope.set({ company_id: row.company_id });
                                        this.DefaultCurrency.current?.setValueOne(row.default_currency_id);
                                        this.Name.current?.setValue(row.name);
                                        this.Country.current?.setValue(row.country);
                                        this.Description.current?.setValue(row.description);
                                        this.Enabled.current?.setValueBool(row.enabled);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxEntity<CurrencyRow>
                        ref={this.DefaultCurrency} title="Default Currency" info={{ link: "https://namirasoft.com/erp/console-guide/branch/#field-default-currency" }} required multiple={false}
                        table_name="currency" table={db.tables.currency}
                        list={(filters, page, size, sorts) => this.props.servers.erp.currency.List(filters, page, size, sorts, null)}
                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxString ref={this.Name} required title="Name" info={{ link: "https://namirasoft.com/erp/console-guide/branch/#field-name" }} style={{ width: NSBox.width.double }} />
                    <NSBoxString ref={this.Country} required={false} title="Country" info={{ link: "https://namirasoft.com/erp/console-guide/branch/#field-country" }} style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" info={{ link: "https://namirasoft.com/erp/console-guide/branch/#field-description" }} style={{ width: NSBox.width.double }} />
                    <NSBoxBoolean ref={this.Enabled} required checked={true} title="Enabled" info={{ link: "https://namirasoft.com/erp/console-guide/branch/#field-enabled" }} style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}